var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "SmoothReflow",
    {
      staticClass: "form-text text-danger m-0",
      attrs: { options: { property: ["height", "margin-top"] } },
    },
    [
      _vm.hasError(_vm.name)
        ? _c("span", {
            staticClass: "d-block pt-2",
            staticStyle: { "font-size": "0.9rem" },
            attrs: { role: "alert" },
            domProps: { textContent: _vm._s(_vm.getErrorText(_vm.name)) },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }